import React from 'react'

import { Payload as LegendPayload } from 'recharts/types/component/DefaultLegendContent'

type DefaultLegendProps = {
    payload: LegendPayload[]
}

export const DefaultLegend: React.FC<DefaultLegendProps> = ({ payload }) => {
    return (
        <ul className="flex flex-wrap gap-x-4 gap-y-3">
            {payload.map((entry, index) => (
                <CustomLegendItem key={index} entry={entry} />
            ))}
        </ul>
    )
}

type CustomLegendItemProps = {
    entry: LegendPayload
}

const CustomLegendItem: React.FC<CustomLegendItemProps> = ({ entry }) => {
    return (
        <li className="text-label-xsmall flex items-center gap-1">
            <div
                className={`h-2 w-2 shrink-0 rounded-full bg-[currentColor]`}
                style={{ color: entry.color }}
            />
            {entry.value}
        </li>
    )
}
